let user = getCookie("isloggedIn");

if(user == "true")
{
  $("#MainContent .shopify-section:not(.password-protection)").show();
  $("#MainContent .password-protection").hide();
}

$(document).on("click",".pswd-check",function(){
  var pss = $(this).attr("data-content");
  var input = $(".password").val();
  if(input === pss)
  {
    setCookie("isloggedIn", "true", 1);
    $("#MainContent .shopify-section:not(.password-protection)").show();
    $("#MainContent .password-protection").hide();
    $(".password-protection-error span").removeClass("show");
  }
  else
  {
    $(".password-protection-error span").addClass("show");
  }
});


function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  let expires = "expires="+d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(';');
  for(let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}